import React from 'react';
import { ClipboardCheck, MessageSquare, FileText, Hammer, CheckCircle2 } from 'lucide-react';

const steps = [
  {
    icon: MessageSquare,
    title: 'Prise de contact',
    description: 'Premier échange pour comprendre vos besoins et votre projet. Disponible par téléphone ou formulaire.',
    number: '01'
  },
  {
    icon: ClipboardCheck,
    title: 'Étude du projet',
    description: 'Visite sur place pour évaluer la surface, les contraintes techniques et vous conseiller sur les meilleurs choix.',
    number: '02'
  },
  {
    icon: FileText,
    title: 'Devis détaillé',
    description: 'Établissement d\'un devis gratuit, transparent et sans engagement avec détail des travaux et des coûts.',
    number: '03'
  },
  {
    icon: Hammer,
    title: 'Réalisation',
    description: 'Intervention rapide et soignée dans le respect des délais convenus. Suivi régulier de l\'avancement.',
    number: '04'
  },
  {
    icon: CheckCircle2,
    title: 'Finitions',
    description: 'Contrôle qualité final, nettoyage complet du chantier et réception des travaux à votre satisfaction.',
    number: '05'
  }
];

const Process = () => {
  return (
    <section id="process" className="py-20 bg-gradient-to-br from-gray-50 to-gray-100">
      <div className="container mx-auto px-4">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Notre <span className="text-blue-600">Process</span>
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Un déroulement structuré en 5 étapes pour garantir 
            la réussite de votre projet
          </p>
        </div>

        {/* Process Steps */}
        <div className="max-w-5xl mx-auto">
          <div className="relative">
            {/* Vertical Line - Desktop */}
            <div className="hidden md:block absolute left-1/2 top-0 bottom-0 w-0.5 bg-blue-200 -translate-x-1/2"></div>

            {/* Steps */}
            <div className="space-y-12">
              {steps.map((step, index) => (
                <div 
                  key={index}
                  className={`relative flex items-center ${
                    index % 2 === 0 ? 'md:flex-row' : 'md:flex-row-reverse'
                  } flex-col gap-8`}
                >
                  {/* Content Card */}
                  <div className={`md:w-5/12 ${index % 2 === 0 ? 'md:text-right' : 'md:text-left'} text-left`}>
                    <div className="bg-white rounded-xl p-6 shadow-lg hover:shadow-xl transition-shadow">
                      <div className={`flex items-start gap-4 ${index % 2 === 0 ? 'md:flex-row-reverse' : ''}`}>
                        <div className="bg-blue-50 rounded-lg p-3 flex-shrink-0">
                          <step.icon className="w-6 h-6 text-blue-600" />
                        </div>
                        <div className="flex-1">
                          <h3 className="text-xl font-bold text-gray-900 mb-2">
                            {step.title}
                          </h3>
                          <p className="text-gray-600 leading-relaxed">
                            {step.description}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* Center Circle with Number */}
                  <div className="md:w-2/12 flex justify-center">
                    <div className="relative">
                      <div className="w-16 h-16 bg-blue-600 rounded-full flex items-center justify-center shadow-lg z-10 relative">
                        <span className="text-white font-bold text-lg">{step.number}</span>
                      </div>
                      {/* Pulse Effect */}
                      <div className="absolute inset-0 bg-blue-400 rounded-full animate-ping opacity-25"></div>
                    </div>
                  </div>

                  {/* Spacer for alternating layout */}
                  <div className="hidden md:block md:w-5/12"></div>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* Bottom CTA - REMOVED - Site statique */}
        <div className="text-center mt-16">
          <div className="bg-white rounded-2xl shadow-xl p-8 max-w-3xl mx-auto">
            <h3 className="text-2xl font-bold text-gray-900 mb-3">
              Prêt à démarrer votre projet ?
            </h3>
            <p className="text-gray-600">
              Contactez-nous dès maintenant par téléphone ou email (coordonnées en bas de page)
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Process;
